import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '@/components/landing/Header';
import HeroSection from '@/components/landing/HeroSection';
import TrustStrip from '@/components/landing/TrustStrip';
import HowItWorks from '@/components/landing/HowItWorks';
import Industries from '@/components/landing/Industries';
import VoiceAISection from '@/components/landing/VoiceAISection';
import AudioDemo from '@/components/landing/AudioDemo';
import ToolsSection from '@/components/landing/ToolsSection';
import WhatSetsUsApart from '@/components/landing/WhatSetsUsApart';
import AboutSection from '@/components/landing/AboutSection';
import AuditForm from '@/components/landing/AuditForm';
import Footer from '@/components/landing/Footer';

const LandingPage = () => {
  const { section } = useParams();

  useEffect(() => {
    const target = section || window.location.hash.replace('#', '');
    if (target) {
      setTimeout(() => {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [section]);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FAFAF9]">
      <Header />
      <main>
        <HeroSection />
        <TrustStrip />
        <HowItWorks />
        <ToolsSection />
        <Industries />
        <VoiceAISection />
        <AudioDemo />
        <WhatSetsUsApart />
        <AboutSection />
        <AuditForm />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
